// import ButtonBaca from "./buttonbaca";

function Hero({onHandleClickMenu, menus}) {
  return (
    <section className="hero max-w-6xl mx-auto mt-20 px-5 lg:px-0">
      <h1 className="lg:text-[70px] text-4xl leading-tight lg:leading-[80px] tracking-[-0.7px] font-semibold">
        In The Name of Allah, The Most Gracious, The Most Merciful
      </h1>
      <div className="flex flex-col lg:flex-row my-8 gap-7">
        <img src="./al-quran.png" alt="" className="w-[699px]" />

        <div className="flex flex-col gap-8">
          <h1 className="text-base lg:text-lg font-medium tracking-[-0.7px]">
            Selamat datang di Platform Baca Al-Quran kami, tempat Anda dapat
            memulai perjalanan transformatif melalui teks suci Islam. Platform
            kami dirancang untuk memberikan pengalaman yang komprehensif dan
            memperkaya bagi mereka yang ingin memperdalam pemahaman mereka
            tentang Al-Quran.
          </h1>
          <h2 className="text-base lg:text-lg font-medium tracking-[-0.7px]">
            Baik Anda seorang sarjana berpengalaman atau pemula yang ingin tahu,
            antarmuka kami yang mudah digunakan dan fitur-fitur canggih akan
            memandu Anda melalui hikmah mendalam yang terkandung dalam ayat-ayat
            suci ini. Benamkan diri Anda dalam keindahan bahasa Arab Al-Quran,
            jelajahi berbagai terjemahan, dan dapatkan wawasan dari komentar
            para ahli.
          </h2>

          <div className="flex flex-col gap-4">
            {/* <ButtonBaca onHandleClickMenu={onHandleClickMenu} menu={menus[1]} /> */}
            <div
              href="#"
              className="border-2 border-hijau text-hijau flex text-base lg:text-[20px] font-medium justify-center py-4 rounded-xl"
            >
              Jadwal Sholat
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
